import type { QueryClient } from '@tanstack/react-query';
import { useAppStore } from './index';

// gloss
export const subscribeHubScopedCache = (queryClient: QueryClient): (() => void) => {
  let previousHubUuid = useAppStore.getState().hubBrand.uuid;

  return useAppStore.subscribe((state) => {
    const hubUuid = state.hubBrand.uuid;
    if (hubUuid === undefined) return;

    if (state.brandScope.space !== 'hub') return;

    const previous = previousHubUuid;
    previousHubUuid = hubUuid;

    if (previous === undefined || previous === hubUuid) return;

    queryClient.clear();
  });
};
